import React, { useState } from 'react';
import Modal from 'react-modal';
import { Button, TextField } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CancelIcon from '@mui/icons-material/Cancel';
import SessionConstants from '../../config/SessionConstants';
import muiInputStyles from '../../uiComponents/MuiInput/MuiInputStyles';

import './index.css';

export default function DevLoginModal(props) {
  const isModalOpen = props.isModalOpen;
  const closeModal = props.closeModal;
  const classes = muiInputStyles();
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [devLoginUsername, setDevLoginUsername] = React.useState('');
  const [devLoginPassword, setDevLoginPassword] = React.useState('');

  const onUsernameChange = (value) => {
    setDevLoginUsername(value);
    setUsernameError(value.trim() === "");
  };

  const onPasswordChange = (value) => {
    setDevLoginPassword(value);
    setPasswordError(value.trim() === "");
  };

  const devLoginFunction = (e) => {
    e.preventDefault(); 
    if (devLoginUsername.trim() === "") {
      setUsernameError(true);
    }
    if (devLoginPassword.trim() === "") {
      setPasswordError(true);
    }

    if (devLoginUsername.trim() !== "" && devLoginPassword.trim() !== "") {
      // Proceed with login
      sessionStorage.setItem(SessionConstants.DEVLOGIN, 'true');
      sessionStorage.setItem(SessionConstants.DEVLOGIN_USERNAME, devLoginUsername);
      sessionStorage.setItem(SessionConstants.DEVLOGIN_PASSWORD, devLoginPassword);
      window.location.href = '/oauth-callback';
    }
  };

  return (
    <>
      <Modal
        className="modal"
        overlayClassName="modalOverlay"
        aria-modal="true"
        contentLabel="Dev Login"
        shouldCloseOnOverlayClick={true}
        isOpen={isModalOpen}
        onRequestClose={closeModal}
      >
        <form method="POST" action="/login" onSubmit={devLoginFunction}>
          <div className="modalHeader">Dev Login</div>
          <div className="modalContent">
            <div className="requiredMessageContainer center">
              <span className="requiredIndicator">*</span> Indicates a required field.
            </div>
            <div className="devLoginInput modalSection">
              <TextField
                className={classes.muiInputs}
                size="small"
                id="devLogin_username"
                variant="outlined"
                label="Username"
                onChange={(e) => onUsernameChange(e.target.value)}
                required
                error={usernameError}
                helperText={usernameError ? "Username is required" : ""}
              />
            </div>
            <div className="devLoginInput">
              <TextField
                className={classes.muiInputs}
                size="small"
                id="devLogin_password"
                variant="outlined"
                label="Password"
                type="password"
                onChange={(e) => onPasswordChange(e.target.value)}
                required
                error={passwordError}
                helperText={passwordError ? "Password is required" : ""}
              />
            </div>
          </div>
          <div className="modalButtons">
            <Button
              style={{ margin: "0 10px", width: "180px" }}
              color="primary"
              variant="contained"
              aria-label="do dev login"
              type="submit"
            >
              <ArrowForwardIcon className="landingButtonIcons" fontSize='small'></ArrowForwardIcon>
              Login
            </Button>
            <Button
              onClick={closeModal}
              style={{ margin: "0 10px", width: "180px" }}
              variant="contained"
              aria-label="cancel dev login"
            >
              <CancelIcon className="landingButtonIcons" fontSize='small'></CancelIcon>
              Cancel
            </Button>
          </div>
        </form>
      </Modal>
    </>
  );
}
